(() => {
  const guideCategory = document.currentScript.getAttribute("data-product-category");

  const startIndexFromCategory = (category) => {
    switch (category) {
      case "waist":
        return 1;
      case "jeans":
        return 1;
      case "shirt":
        return 2;
      case "business-shirt":
        return 2;
      case "shoes":
        return 3;
      default:
        return 0;
    }
  };

  const sgState = {
    currentView: undefined,
    currentTransition: undefined,
    backdropId: undefined,
    opener: undefined,
    releaseFocus: undefined,
  };

  const manualSgState = {
    sizeGuideManualSplide: undefined,
    startIdx: 0,
    openedIdx: 0,
  };

  const getSidebarElems = () => {
    const sizeGuideContainer = document.querySelector("#size-guide-modal");
    const closeBtn = sizeGuideContainer.querySelector(".size-guide-modal__close-btn");
    const backBtn = sizeGuideContainer.querySelector(".size-guide-modal__back-btn");
    const calculatorBtns = sizeGuideContainer.querySelectorAll(".size-guide-modal__buttons .size-guide-modal__calc-opt-buttons-list .size-guide-modal__calc-opt-button");
    const calculatorSelectionView = sizeGuideContainer.querySelector(".size-guide-modal__buttons");
    const calculatorViews = sizeGuideContainer.querySelectorAll(".size-guide-modal__calculator");

    return {
      backBtn,
      sizeGuideContainer,
      closeBtn,
      calculatorSelectionView,
      calculatorBtns,
      calculatorViews,
    };
  };

  const openSizeGuide = (elems, opener) => {
    if (sgState.opener) return;
    const category = opener.getAttribute("data-size-guide-category");
    manualSgState.startIdx = startIndexFromCategory(category);
    for (const btn of elems.calculatorBtns) {
      btn.parentElement.hidden = category !== guideCategory && btn.getAttribute("data-sg-target") !== "manual";
    }
    elems.sizeGuideContainer.classList.add("size-guide-modal--animated");
    elems.sizeGuideContainer.setAttribute("aria-hidden", false);
    elems.sizeGuideContainer.removeAttribute("inert");
    elems.sizeGuideContainer.classList.add("size-guide-modal--open");
    sgState.opener = opener;
    opener.setAttribute("aria-expanded", true);
    sgState.releaseFocus = window.holdOverlayFocus(elems.sizeGuideContainer, elems.closeBtn, () => window.popBackdrop(sgState.backdropId));
    switchView(elems, "buttons", false);

    sgState.backdropId = window.pushBackdrop({
      closeCallback: () => closeSizeGuide(elems),
      hideNavbar: true,
      clickToClose: true,
    });
    window.freezeDocumentHeight();
  };

  const closeSizeGuide = (elems) => {
    elems.sizeGuideContainer.setAttribute("aria-hidden", true);
    elems.sizeGuideContainer.setAttribute("inert", true);
    elems.sizeGuideContainer.classList.remove("size-guide-modal--open");
    window.unfreezeDocumentHeight();
    sgState.backdropId = undefined;
    sgState.opener?.setAttribute("aria-expanded", false);
    sgState.opener = undefined;
    sgState.releaseFocus?.();
    sgState.releaseFocus = undefined;
  };

  const openEvent = new CustomEvent("sg-pageopen");
  const hideEvent = new CustomEvent("sg-pagehide");

  const elemWithCorrectAttr = (elems, attr, target) => {
    for (const e of elems) {
      if (e.getAttribute(attr) === target) return e;
    }
    return undefined;
  };

  const switchView = (elems, sgTarget, animate = false) => {
    if (sgState.currentView === sgTarget) {
      console.warn(`switching to same view (${sgTarget})`);
      return;
    }

    const hideView = (target) => {
      if (target === "buttons") {
        elems.calculatorSelectionView.classList.remove("size-guide-modal__buttons--open");
        elems.calculatorSelectionView.setAttribute("aria-hidden", true);
        elems.calculatorSelectionView.setAttribute("inert", true);
        elems.calculatorSelectionView.dispatchEvent(hideEvent);
      } else {
        const assocBtn = elemWithCorrectAttr(elems.calculatorBtns, "data-sg-target", target);
        const assocPage = elemWithCorrectAttr(elems.calculatorViews, "data-sg-display", target);

        if (assocBtn === undefined || assocPage === undefined) {
          console.warn(`cannot hide view - no matching btn or page for view '${target}'`, { assocBtn, assocPage });
          return;
        }

        assocBtn.setAttribute("aria-expanded", false);
        assocPage.classList.remove("size-guide-modal__calculator--open");
        assocPage.setAttribute("aria-hidden", true);
        assocPage.setAttribute("inert", true);
        assocPage.dispatchEvent(hideEvent);
      }
    };

    const showView = (target) => {
      if (target === "buttons") {
        elems.calculatorSelectionView.classList.add("size-guide-modal__buttons--open");
        elems.calculatorSelectionView.setAttribute("aria-hidden", false);
        elems.calculatorSelectionView.removeAttribute("inert");
        hideBackBtn(elems.backBtn);

        if (sgState.currentView) {
          elemWithCorrectAttr(elems.calculatorBtns, "data-sg-target", sgState.currentView).focus();
        } else {
          elems.closeBtn.focus();
        }

        elems.calculatorSelectionView.dispatchEvent(openEvent);
      } else {
        enableBackBtn(elems.backBtn);
        const assocBtn = elemWithCorrectAttr(elems.calculatorBtns, "data-sg-target", target);
        const assocPage = elemWithCorrectAttr(elems.calculatorViews, "data-sg-display", target);

        if (assocBtn === undefined || assocPage === undefined) {
          console.warn(`cannot show view - no matching btn or page for view '${target}'`, { assocBtn, assocPage });
          return;
        }

        assocBtn.setAttribute("aria-expanded", true);
        assocPage.classList.add("size-guide-modal__calculator--open");
        assocPage.setAttribute("aria-hidden", false);
        assocPage.removeAttribute("inert");
        assocPage.querySelector(".size-guide-modal__calculator-close-btn")?.focus();
        assocPage.dispatchEvent(openEvent);
      }
    };

    const updateDOM = () => {
      if (sgState.currentView !== undefined) hideView(sgState.currentView);
      showView(sgTarget);
      sgState.currentView = sgTarget;
    };

    if (animate && document.startViewTransition) {
      if (sgState.currentTransition) {
        sgState.currentTransition.skipTransition();
      }

      sgState.currentTransition = document.startViewTransition(updateDOM);
    } else {
      updateDOM();
    }
  };

  const onCalcBtnClick = (clickedBtn, sidebarElems) => {
    const targetPage = clickedBtn.getAttribute("data-sg-target");
    if (!targetPage) {
      console.warn("target page attribute (data-sg-target) for selected button does not exist: ", clickedBtn);
      return;
    }

    switchView(sidebarElems, targetPage, true);
  };

  const onCalcCloseBtn = (sidebarElems) => {
    switchView(sidebarElems, "buttons", true);
  };

  const mountSgManualSplide = () => {
    manualSgState.sizeGuideManualSplide = new Splide("#size-guide-calculator--manual .sg-manual__slides", {
      label: "Size Guides Available",
      arrows: false,
      pagination: false,
      drag: false,
      wheel: false,
      keyboard: false,
      start: manualSgState.startIdx,
    }).mount();
  };

  const unmountSgManualSplide = () => {
    manualSgState.sizeGuideManualSplide.destroy(false);
  };

  const enableBackBtn = (btn) => {
    btn.classList.add("size-guide-modal__back-btn--active");
  };

  const hideBackBtn = (btn) => {
    btn.classList.remove("size-guide-modal__back-btn--active");
  };

  const enableNavBtn = (btn) => {
    btn.classList.add("sg-manual__nav-list-btn--active");
  };

  const disableNavBtn = (btn) => {
    btn.classList.remove("sg-manual__nav-list-btn--active");
  };

  const navBtnClick = (clickedBtn, allBtns) => {
    const newIdx = allBtns.indexOf(clickedBtn);
    if (newIdx === -1) {
      console.warn("clicked btn does not exist in the nav btns array", {
        allBtns,
        clickedBtn,
        btnIdx: newIdx,
      });
      return;
    }

    if (manualSgState.openedIdx !== undefined && manualSgState.openedIdx < allBtns.length) {
      disableNavBtn(allBtns[manualSgState.openedIdx]);
    }
    enableNavBtn(clickedBtn);

    if (manualSgState.openedIdx !== newIdx) {
      manualSgState.openedIdx = newIdx;
      manualSgState.sizeGuideManualSplide.go(newIdx);
    }
  };

  const onTblScroll = (event) => {
    const border = event.target.scrollLeft > 0.5 ? "var(--neutral-200)" : "transparent";
    for (const header of event.target.querySelectorAll("th")) {
      header.style.borderColor = border;
    }
  };

  const syncNavButtons = (navBtns, activeIdx) => {
    for (let i = 0; i < navBtns.length; i++) {
      if (i == activeIdx) {
        enableNavBtn(navBtns[i]);
      } else {
        disableNavBtn(navBtns[i]);
      }
    }
  };

  const initManualSizeGuide = (page) => {
    const navBtns = Array.from(page.querySelectorAll(".sg-manual__nav-list .sg-manual__nav-list-btn"));
    for (const navBtn of navBtns) {
      navBtn.addEventListener("click", () => navBtnClick(navBtn, navBtns));
    }
    syncNavButtons(navBtns, manualSgState.openedIdx);

    page.addEventListener("sg-pageopen", () => {
      mountSgManualSplide();
      manualSgState.openedIdx = manualSgState.startIdx;
      syncNavButtons(navBtns, manualSgState.openedIdx);
    });
    page.addEventListener("sg-pagehide", () => unmountSgManualSplide());

    for (const tbl of page.querySelectorAll(".sg-manual__sizes, .sg-manual-suits__panel")) {
      tbl.addEventListener("scroll", onTblScroll);
    }
  };

  const init = () => {
    const sidebarElems = getSidebarElems();

    document.addEventListener("click", (event) => {
      const button = event.target.closest(".size-guide-button");
      if (button) openSizeGuide(sidebarElems, button);
    });
    sidebarElems.closeBtn.addEventListener("click", () => {
      if (sgState.backdropId !== undefined) {
        window.popBackdrop(sgState.backdropId);
      }
    });

    sidebarElems.backBtn.addEventListener("click", () => {
      if (sgState.currentView === "buttons") return;

      switchView(sidebarElems, "buttons", true);
    });

    const pageIdConfigMap = new Map([
      ["size-guide-calculator--quick", (page) => new window.SizeGuide(page, "easy")],
      ["size-guide-calculator--precise", (page) => new window.SizeGuide(page, "precise")],
      ["size-guide-calculator--manual", initManualSizeGuide],
    ]);

    for (const page of sidebarElems.calculatorViews) {
      const closeBtn = page.querySelector(".size-guide-modal__calculator-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => onCalcCloseBtn(sidebarElems));
      }

      pageIdConfigMap.get(page.id)?.(page);
    }

    for (const btn of sidebarElems.calculatorBtns) {
      btn.addEventListener("click", () => onCalcBtnClick(btn, sidebarElems));
    }
  };

  init();
})();
